import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {DepartmentType} from './departments';

export interface DepartmentRemoverModalInterface {
  open: boolean
  department: DepartmentType | null
}

// Stateの初期状態
const initialState: DepartmentRemoverModalInterface = {
  open      : false,
  department: null
};

// Sliceを生成する
const slice = createSlice({
  name    : 'department-remover-modal',
  initialState,
  reducers: {
    open : (state, action: PayloadAction<DepartmentType>) => {
      return {...state, open: true, department: action.payload};
    },
    close: (state) => {
      return {...state, open: false};
    },
  }
});

// Reducerをエクスポートする
export default slice.reducer;

// Action Creatorsをエクスポートする
export const {open, close} = slice.actions;
